import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@shared/i18n/config/languages';
import { persistLanguage } from '@shared/i18n/lib/persist-locale';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/ui';

export function InvoiceLanguageMenu() {
  const { t, i18n } = useTranslation('invoice-pay');

  const changeLanguage = (value: string) => {
    void i18n.changeLanguage(value);
    persistLanguage(value);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-5 shrink-0 rounded-none p-0 text-foreground hover:bg-transparent hover:opacity-70"
          aria-label={t('languageMenu')}
        >
          <Globe className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {SUPPORTED_LANGUAGES.map((code) => (
          <DropdownMenuItem
            key={code}
            className="cursor-pointer"
            onSelect={() => changeLanguage(code)}
          >
            {t(`languages.${code}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
